import React, { useState } from 'react';
import moment from 'moment';
import useWindowSize from 'react-use/lib/useWindowSize';
import isAfterDay from '../../_helpers/dates/isAfterDay';
import 'react-dates/initialize';

// Components
import { DayPickerRangeController } from 'react-dates';
import DatesSelected from './DatesSelected';

type FocusInput = 'startDate' | 'endDate' | null;

interface Props {
  onChange: (value: any, key: string) => void;
  form: {
    startDate?: any;
    endDate?: any;
  };
}

export default function DateRangePickerOverride({ form, onChange }: Props) {
  const [focusedInput, setFocus] = useState('startDate' as any);
  const { width } = useWindowSize();
  let numberOfMonths = 1;
  let visibleMonths = 0;

  if (width > 992) {
    numberOfMonths = 3;
    visibleMonths = 2;
  } else if (width > 650) {
    numberOfMonths = 2;
    visibleMonths = 1;
  }

  return (
    <>
      <DayPickerRangeController
        minimumNights={0}
        startDate={form.startDate}
        endDate={form.endDate}
        focusedInput={focusedInput}
        onFocusChange={(focusedInput: FocusInput) => {
          if (focusedInput === null) {
            setFocus('startDate');
          } else {
            setFocus(focusedInput);
          }
        }}
        numberOfMonths={numberOfMonths}
        onDatesChange={(value: any) => {
          onChange(value.startDate, 'startDate');
          onChange(value.endDate, 'endDate');
        }}
        enableOutsideDays
        isOutsideRange={day => isAfterDay(day, moment().subtract(1, 'day'))}
        hideKeyboardShortcutsPanel
        initialVisibleMonth={() => moment().subtract(visibleMonths, 'months')}
      />
      <br />
      {!!form.startDate && !!form.endDate && <DatesSelected form={form} />}
    </>
  );
}
